<template>
    <div class="info-container clearfix">
        <el-form :inline="true" :model="roomForm" class="demo-form-inline">
            <el-form-item label="房间名">
                <el-input type="text" size="medium" v-model="roomForm.name"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="medium">{{$t('btns.search')}}</el-button>
                <!-- <el-button @click="onSubmit" size="medium">{{$t('btns.exports')}}</el-button> -->
            </el-form-item>
        </el-form>

        <div class="add-household-box">
            <el-button type="primary" size="medium" @click="addDoorCard">+{{$t('btns.add')}}房间</el-button>
        </div>
        <el-table :data="roomList" style="width: 100%" v-loading="loading">
            <el-table-column label="#" width="50" type="index" :index="1">
            </el-table-column>
            <el-table-column label="房间名">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.housename}}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('residence.roomArea')">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.area}}&nbsp;m²</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('residence.remark')">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.description}}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('project.operation')">
                <template slot-scope="scope">
                    <el-button @click="editRoom(scope.row)" type="text">{{$t('btns.verify')}}</el-button>
                    <el-button type="text" @click="deleteRoom(scope.row)">{{$t('btns.delete')}}</el-button>
                    <!-- <el-button type="text">绑定设备</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <!-- <div style="float:right; padding-top: 24px" v-if="residenceList.total > pageSize">
            <el-pagination :page-size="pageSize" background layout="prev, pager, next" :total="residenceList.total" @current-change="currentChange">
            </el-pagination>
        </div> -->

        <!-- 新增房间弹框 -->
        <cmp-house-form
            @handleCloseDialog="listenDialogClose"
            :visible="visible"
            :moduleidlist="moduleidlist"
            :formData="formData"
        ></cmp-house-form>
    </div>
</template>

<script>
import CmpHouseForm from '../CmpHouseForm/CmpHouseForm'
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
export default {
    name: "DoorCard",
    props: ["hBreadcrumb", "addForm"],
    inject: ['reload'],
    data() {
        return {
            roomForm: {
                name: '',
            },
			tmpDes:[],
            roomList:[],    //  房间列表

            visible: false,
            formData:{},
			building_index:0,
            loading: false,
            page: 1,
            pageSize: 10,
        };
    },
    computed: {
        moduleidlist() {
            let Arr = [];
            this.hBreadcrumb.map(v=>{
                let obj = {};
                obj.moduleid = v.oid;
                obj.modulename = v.modulename;
                obj.typename = v.typename;
                Arr.push(obj)  
            })
            return Arr
        }
    },
    mounted() {
		this.$store.dispatch("GetProjectInfo").then( res => {
		    // 获取模型结构
		    Service.getTemplate({oid:res.buildings_template_id}).then(ress => {
		        this.tmpDes = JSON.parse(ress.description);
				this.getHouseList(JSON.parse(ress.description));
		    })
		}).catch(res=>{
			
		})
        
    },
    components: {
        CmpHouseForm
    },
    methods: {
        // 获取当前楼层房间
        async getHouseList(list) {
            this.loading = true;
			let arr=this.fmdata(list)
			this.building_index=arr[arr.length - 1].id
            let data = await Service.getHouseList({OID: this.addForm.previous,building_index:this.building_index,house_name:''});
            this.loading = false;
            if(data && data != 'success') {
                this.roomList = data;
            }
        },
        // 添加房间弹框开启
        addDoorCard() {
            this.formData = {}
            this.visible = true;
        },
		fmdata(data){
			return data.reduce((arr, { id, typename, children = [] }) =>
			    arr.concat([{ id, typename }], this.fmdata(children)), [])
		},
        // 添加房间弹框关闭
        listenDialogClose(bool) {
            this.visible = false;
            if(bool){
                this.getHouseList(this.tmpDes);
            }
        },
        // 删除区域信息
        async deleteRoom(room) {
            $Alert(`确认删除${room.housename}, 是否继续?`).then( async (bool)=>{
                if(bool){
                    let data = await Service.deteleHouse({oid:room.oid});
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!',
                            duration: 1500,
                        });
                        this.getHouseList(this.tmpDes);
                    }
                }   
            });
            
        },
        // 编辑区域信息,向对话框传递需要编辑的信息
        editRoom(data) {
            this.formData = data
            this.visible = true;
        },
       async handleSearch() {
            this.loading = true;
            let data = await Service.getHouseList({OID: this.addForm.previous,building_index:this.building_index,house_name:this.roomForm.name});
            this.loading = false;
            if(data && data != 'success') {
                this.roomList = data;
            }
        },
        currentChange(value) {
            this.page = value;
            this.handleSearch()
        }
    }
}
</script>
<style>
.info-container .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: calc(100% / 3);
}
.info-container .el-table th {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    background: #fafafa;
}
.info-container .el-alert--success {
    background-color: #e6f7ff;
    color: #333;
}
</style>

<style scoped>
.info-container {
    padding: 24px 32px;
    background: #fff;
}
.add-household-box,
.tips-box {
    margin: 0 0 24px;
}

.tips-item {
    padding-right: 4px;
}
</style>
